module.exports = __webpack_public_path__ + "media/images/sp/plans/reason_02-88cc950f79c61ebf23f1657bc58159fb.jpg";